import LayoutExternal from 'Layout/Layout/LayoutExternal'
import React, { useEffect, useState } from 'react'
import qs from 'qs'
import styles from './VerifyEmail.module.scss'
import ModalSuccess from 'pages/Profile/Package/ModalSuccess'
import ModalWrong from 'components/Modal/ModalWrong'
import { HomeTwoTone } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { TranslateLanguage } from 'util/Translate'
import { vocabVerifyEmail } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabVerifyEmail)

export default function VerifyEmail() {
  const getQS = qs.parse(window.location.search.split('?')[1])
  const [visibleSuccess, setVisibleSuccess] = useState(false)
  const [visibleWrong, setVisibleWrong] = useState(false)

  useEffect(() => {
    if (getQS.success === 'true') {
      setVisibleSuccess(true)
    } else if (getQS.success === 'false') {
      setVisibleWrong(true)
    }
  }, [getQS.success])

  return (
    <LayoutExternal>
      <div>
        <div className={styles.divTextToHome}>
          <Link to='/' >
            <HomeTwoTone className={styles.iconBack} alt='IconBack' twoToneColor={'#0baf50'} />
            <p >เข้าสู่หน้าหลัก</p>
          </Link>
        </div>

        <ModalSuccess
          visible={visibleSuccess}
          setVisible={setVisibleSuccess}
          title={translate.convert('ผลการการยืนยัน Email ของคุณสำเร็จ')}
          setBody=''
        >
        </ModalSuccess>
        <ModalWrong
          visible={visibleWrong}
          setVisible={setVisibleWrong}
          title={translate.convert('ผลการการยืนยัน Email ของคุณไม่สำเร็จ')}
          setBody=''
        >
        </ModalWrong>

      </div>

    </LayoutExternal>
  )
}
